export default __webpack_public_path__ + "static/media/img9.1861a6ef.jpg";